// extracted by mini-css-extract-plugin
export default {"example":"Examples_example__A30v8"};